export const payoutTheme = {
  colors: {
    primary: "#1B163B",
    accent: "#6687FF",
    border: "#E0E5F2",
    muted: "#505E8E",
    surface: "#FFFFFF",
    canvas: "#F6F8FA",
  },
};

export const payoutUi = {
  button: {
    base: "inline-flex h-10 items-center justify-center gap-3 rounded-[6px] px-4 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50",
    primary: "bg-[#1B163B] text-white shadow-sm hover:bg-[#1B163B]/95",
    secondary: "border border-[#E0E5F2] bg-white text-[#1B163B] hover:bg-[#F6F8FA]",
    subtle: "border border-[#E0E5F2] bg-white text-[#6687FF] hover:bg-[#F6F8FA]",
    danger: "border border-[#FCA5A5] bg-white text-[#DC2626] hover:bg-[#FEF2F2]",
    icon: "flex h-8 w-8 items-center justify-center rounded-[6px] text-[#1B163B] hover:bg-[#A9B2CF1A]",
  },
  card: "rounded-[8px] border border-[#E0E5F2] bg-white new-shadow",
  cardPadding: "p-5",
  panel: "h-fit rounded-[8px] border border-[#E0E5F2] bg-white p-5 new-shadow",
  ctaRow:
    "flex flex-wrap items-center justify-between gap-4 rounded-[8px] border border-[#E0E5F2] bg-white p-5 new-shadow",
  flowActionBar:
    "mb-6 flex min-h-[80px] flex-wrap items-center justify-between gap-5 bg-white px-5 py-4",
  chip: {
    item: "inline-flex h-8 max-w-full items-center gap-2 rounded-[6px] bg-[#6687FF] px-3 text-xs font-semibold text-white shadow-sm",
    text: "max-w-[220px] truncate",
    remove:
      "payout-filter-chip-remove flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-white/15 text-white hover:bg-white/25",
    clear:
      "inline-flex h-8 items-center rounded-[6px] border border-[#E0E5F2] bg-white px-3 text-xs font-semibold text-[#6687FF]",
  },
  table: {
    surface:
      "payout-table-surface overflow-hidden rounded-[8px] border border-[#E0E5F2] bg-white p-4 new-shadow",
    header: "mb-4 flex flex-wrap items-center justify-between gap-3 bg-white",
    title: "text-[18px] font-semibold leading-6 text-[#1B163B]",
    base: "payout-table-base overflow-hidden rounded-[8px] bg-[#F6F8FA]",
    headerRow:
      "w-full bg-[#A9B2CF1A] font-medium mx-5 rounded-lg text-sm text-[#1B163B]",
    headerCell: "h-12 py-3 first:px-6 px-4 max-w-[15rem] align-middle font-medium",
    row: "h-[64px] bg-white overflow-visible w-full new-shadow",
    cell: "flex text-xs gap-x-2 items-center max-w-[15rem]",
    scroll: "payout-table-scroll grid grid-cols-1 overflow-x-scroll p-4 pb-5",
  },
  emptyState: {
    wrapper:
      "flex min-h-[220px] flex-col items-center justify-center px-6 py-10 text-center",
    icon: "flex h-12 w-12 items-center justify-center rounded-[8px] bg-[#1B163B0D] text-xl text-[#1B163B]",
    title: "mt-4 text-[17px] font-semibold text-[#1B163B]",
    description: "mt-2 max-w-[460px] text-sm font-medium leading-6 text-[#505E8E]",
    actions: "mt-5 flex flex-wrap items-center justify-center gap-3",
  },
  stepper: {
    shell:
      "mb-5 flex flex-wrap items-center justify-between gap-4 border-y border-[#E0E5F2] bg-white px-2 py-5",
    inlineShell: "flex min-w-0 flex-1 flex-wrap items-center gap-8",
    list: "flex flex-wrap items-center gap-8 xl:gap-12",
    item: "flex items-center gap-3",
    circle:
      "flex h-8 w-8 items-center justify-center rounded-full border text-sm font-semibold",
    circleActive: "border-[#1B163B] bg-[#1B163B] text-white",
    circleIdle: "border-[#D8E0F0] bg-white text-[#505E8E]",
    label: "text-sm font-semibold",
    labelActive: "text-[#1B163B]",
    labelIdle: "text-[#505E8E]",
    divider: "hidden h-px w-16 bg-[#D8E0F0] xl:block",
  },
};

export const cx = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(" ");
